import { render, staticRenderFns } from "./TableFixedFields.vue?vue&type=template&id=49bfa7a0"
import script from "./TableFixedFields.vue?vue&type=script&lang=js"
export * from "./TableFixedFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports